import React from 'react';
import CompanyInfoTabView from './CompanyInfoTabView';
import { useCompanyInfoTabController } from '../../../controllers';
import { CompanyInfoTabProps } from '../../../types';

const CompanyInfoTab = (props: CompanyInfoTabProps) => {
  const viewModel = useCompanyInfoTabController(props);
  return <CompanyInfoTabView {...viewModel} />;
};

export default CompanyInfoTab;
